import { Button, IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

type Props = {
  open?: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
};

export const ConcurrentUpdateSnackbar = ({ open, onRefresh, onDismiss }: Props): React.ReactElement => (
  <Snackbar
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={open}
    message="This content has been updated from a different session."
    action={
      <>
        <Button color="secondary" size="small" onClick={onRefresh}>
          Refresh
        </Button>
        <IconButton aria-label="close" color="inherit" onClick={onDismiss} title="Dismiss">
          <CloseIcon />
        </IconButton>
      </>
    }
  />
);
